import { CompaniesApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'

class CompanyService {
  httpClient = createApiClient(CompaniesApi)

  async getByIds(ids: number[]) {
    const { data } = await this.httpClient.getByIds(ids)

    return data
  }

  async getByPartialName(filter: string) {
    const { data } = await this.httpClient.getByPartialName(filter)

    return data
  }

  async getById(id: number) {
    const { data } = await this.httpClient.getById(id)

    return data
  }

  async getByShortName(shortName: string) {
    const { data } = await this.httpClient.getByShortName(shortName)

    return data
  }

  async getByReferenceIds(referenceIds: number[]) {
    const { data } = await this.httpClient.getByReferenceIds({ referenceIds })

    return data
  }
}

const companyService = new CompanyService()

export default companyService
